import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import CustomAlert from '../../components/CustomAlert';
import CustomLoading from '../../components/CustomLoading';
import { paths } from '../../config/router.config';
import wsclients from '../../services/wsclients';
import { readMWCode } from '../../utils/util';
import PublicPage from '../PublicPage'
import OTPView from '../login/OTPView';
import LoginView from './LoginView';
import { configData } from '../../config/main.config';
import { getProviderOrder, saveTokenToCookie, setOrderStatusInfo, setProviderOrder } from '../../utils/commons';
import { order_key, setOrderStatusCache } from '../../utils/order_cache';

export default function LoginController(props) {
    const [showLoading, onShowLoading] = useState(false);
    const [message, setMessage] = useState({});
    const [loginInfo, setLoginInfo] = useState({});
    const history = useHistory();
    const { classes, language } = props;
    const { t } = useTranslation();
    const [active, setActive] = useState('main');
    const [showReferral, setShowRefferral] = useState(false);

    const onLogin = async (values) => {
        console.log('onLogin values=', values);
        const { email, password } = values;
        setLoginInfo({
            email: email,
            password: password
        });
        onShowLoading(true);
        try {
            let result = await wsclients.contacts.authenticateEmail({ 
                username: email,
                password: password,
             }, true);
            console.log("result login===", result);
            if(result.code == 'OK'){
                if(result.data && result.data.access_token) await onLoad();
                else  onShowMessage({ show: true, content: t('INVALID_EMAIL_LOGIN') });
            } else if(result.code=='EMAIL_NOT_VERIFIED'){
                onShowMessage({ show: true, content: t('EMAIL_NOT_VERIFIED') });
            } else {
                onShowMessage({ show: true, content: t('INVALID_EMAIL_LOGIN') });
            }
            // if(email =='test@crmi.vn' && password =='123456'){
            //     saveTokenToCookie('access_token', 'tokenaaaa');
            //     history.push(paths.home);
            // }
        } catch (error) {
            console.log("login/onLoginProcess EXCEPPPPTIONNNN", error);
            onShowMessage({ show: true, content: t('EXCEPTION') })
        }
    }
    const onResendOtp = async () => {
        onShowLoading(true)
        try {
            let result = await wsclients.contacts.onResendOtpProcess(loginInfo);
            console.log('onResendOtp result=', result);
            if (result.code == 'OK') {
                onShowMessage({ show: true, content: t('verify_resendCodeMessage1') + t('verify_resendCodeMessage2') });
            }
            else {
                onShowMessage({ show: true, content: t('EXCEPTION') })
            }
        }
        catch (error) {
            console.log("register/onResendOtp EXCEPPPPTIONNNN", error);
            onShowMessage({ show: true, content: t('EXCEPTION') })
        }

    }
    const onVerifyOtp = async (values) => {
        onShowLoading(true)
        try {
            const { otp_code } = values
            const { mobile, password } = loginInfo;
            const payload = {
                mobile: mobile,
                password: password,
                verification_token: "",
                verification_code: otp_code,
            };
            let result = await wsclients.contacts.onVerifyOtpProcess(payload);
            if (result.code == 'OK') {
                onShowLoading(false)
                history.push(paths.home)
            }
            else {
                onShowMessage({ show: true, content: readMWCode(result.code, t) })
            }
        }
        catch (error) {
            console.log("register/onVerifyOtp EXCEPPPPTIONNNN", error);
            onShowMessage({ show: true, content: t('EXCEPTION') })
        }
    }
    const onShowMessage = (message) => {
        onShowLoading(false)
        setMessage(message)
    }
    
    const renderPage = ()=>{
        if(active == 'main'){
            return (
                <LoginView
                    onLogin={onLogin}
                    language={language}
                    classes={classes}
                    t={t}
                />
            );
        } else {
            return (
                <OTPView
                onLogin={onVerifyOtp}
                onResend={onResendOtp} />
            );
        }
    }

    const onLoad = async () => {
        onShowLoading(true)
        let contact_info = await onLoadContact();
        console.log("contact_info==", contact_info);
        if(contact_info) {
            await onGetOrderStatus(contact_info.id);
        }
        onShowLoading(false)
    }
    
    const onLoadContact =  async () => {
        let contact_info = null;
        try{
            var result = await wsclients.contacts.getContact();
            if(result.code === 'OK'){
                contact_info = result.data;
                if(result.data && result.data.custom_fields && result.data.custom_fields.length > 0) {
                    let existProviderOrder = result.data.custom_fields.filter(x => x.key == 'provider_order');
                    if(existProviderOrder && existProviderOrder.length > 0) {
                        setProviderOrder(existProviderOrder[0].value);
                    }
                }
            }
        }catch(ex){
            console.log("onLoadContact exception===", ex);
        }
        return contact_info;
    }

    const onGetOrderStatus =  async (contact_id) => {
        try{
            let provider_order = getProviderOrder();
            var result = await wsclients.lab4services.getOrderStatus(contact_id, null, provider_order);
            console.log("result order status ===", result);
            if(result.code === 'OK'){
                let order_status = result.data;
                // setOrderStatusInfo(result.data);
                if(result.data) setOrderStatusCache(order_key.order_status, JSON.stringify(result.data))
                if(order_status){
                    history.push(paths.home)
                    // if((order_status.status === 'VUMATEL_ORDER_EXCEPTION'))
                    //     history.push(paths.package_contact);
                    // else {
                    //     history.push(paths.home)
                    // }
                }
            }
            else history.push(paths.home)
        }catch(ex){
            console.log("onGetOrderStatus exception===", ex);
        }
    }
    return (
        <>
            <PublicPage
                rightComponent={renderPage()}
            />
            {message.show && <CustomAlert
                open={message.show}
                message={message.content}
                showButtonClose={true}
                onClose={() => onShowMessage({})}
            />}
            {showLoading && <CustomLoading open={showLoading} />}
        </>
    )
}
